const Course_Id = {
    1: "Renaissance",
    2: "LLD",
    3: "Begin with c++",
    4: "Python",
    5: "Frontend with React",
    6: "DSA Essentials",
    9: "Java Springboot",
    10: "AI Engineering (Cohort 1)",
    11: "AI Engineering (Cohort 2)",
    12: "Agentic AI (Cohort 3)",
    13: "UP Police AI Engineering",
    14: "Deep Learning (Cohort 3)",
    15: "AI Engineering (Cohort 4)",
    16: "AI Engineering (Cohort 5)",
    17: "Deep Learning (Cohort 2)",
};

const Payment_Status = "captured";

const Renaissance_Course_ID = "1";

export { Course_Id, Payment_Status, Renaissance_Course_ID };
